<template>
  <Modal
    v-loading="loading"
    :visible="visible"
    :maskClosable="false"
    :width="isMobile ? '34.4rem' : '742px'"
    centered
    :closable="false"
    :class="{ 'rtl--container': isArSite }"
    >
    <div
      class="information-gathering-container set-mobile-padding"
      :class="isMobile ? 'information-dialog-background-m' : 'information-dialog-background'"
    >
      <div class="information-gathering-illustrate">
        <div class="information-gathering-title set-mobile-title">
          {{ $t('global.fillPersonalInfo') }}
        </div>
        <div class="information-gathering-illustrates set-mobile-illustrates">
          {{ $t('global.gatheringDetail') }}
          <a class="link" target="_blank" :href="isMicro ? 'https://www.hikmicrotech.com/en/policy/elearning/privacy-policy' : 'https://www.hikvision.com/en/elearning/privacy-policy/'">{{ $t('global.privacyPolicy') }}</a>
        </div>
      </div>
      <div class="information-gathering-infor">
        <a-form layout="vertical" :model="dialogState" name="basic" autocomplete="off">
          <div
            v-if="formItemDisplay('firstName')"
            :class="[{
              'first-name-display-inline-block': formItemDisplay('lastName')
            }, {'margin-right-20': formItemDisplay('lastName')} ]"
          >
            <a-form-item name="firstName">
              <Input v-model:value="dialogState.firstName" :label="$t('myLearning.edit.firstName')" :maxlength="30" :title="isMicro ? $t('myLearning.tips.name') : ''" />
            </a-form-item>
          </div>

          <div v-if="formItemDisplay('lastName')" :class="[{ 'last-name-display-inline-block': formItemDisplay('firstName') }]">
            <a-form-item>
              <Input v-model:value="dialogState.lastName" :label="$t('myLearning.edit.lastName')" :maxlength="30" :title="isMicro ? $t('myLearning.tips.name') : ''" />
            </a-form-item>
          </div>

          <div style="display: flex;">
            <div v-if="formItemDisplay('phoneNumber')" class="information-gathering-infor-code">
              <a-form-item>
                <Input :label="$t('myLearning.edit.code')" v-model:value="dialogState.phoneCode" />
              </a-form-item>
            </div>
            <div v-if="formItemDisplay('phoneNumber')" class=" information-gathering-infor-phone-number ">
              <a-form-item name="phoneNumber">
                <Input :label="$t('myLearning.edit.phoneNumber')" v-model:value="dialogState.phoneNumber" :maxlength="30" :title="$t('myLearning.tips.phone')" />
              </a-form-item>
            </div>
          </div>

          <div v-if="formItemDisplay('country')">
            <Select
              v-if="!provinceDataUnavailable"
              v-model:value="dialogState.country"
              :label="$t('myLearning.edit.country')"
              :optionList="countryList.map(i => ({ label: i, value: i }))"
              class="select-list"
              @change="onChangeCountry"
            />
            <Country v-else v-model:value="dialogState.country" placeholder="Country/Region" class="select-list" @change="onChangeCountry" />
          </div>
          <div
            :class="{ 'flex-line': !isMobile }"
            v-if="formItemDisplay('province')"
          >
            <a-form-item name="Province" :class="{ 'margin-right-20': !isMobile && formItemDisplay('city') }" >
              <Select
                v-if="!provinceDataUnavailable"
                v-model:value="dialogState.province"
                class="set-select-width"
                :label="$t('myLearning.edit.province')"
                @change="onChangeProvince"
                :optionList="provinceList.map(i => ({ label: i, value: i }))"
                :title="$t('myLearning.tips.provinceState')"
              />
              <Input v-else v-model:value="dialogState.province" class="set-select-width" :label="$t('myLearning.edit.province')" :title="$t('myLearning.tips.provinceState')" />
            </a-form-item>
            <a-form-item name="city" v-if="formItemDisplay('city')">
              <Select
                v-if="!provinceDataUnavailable"
                v-model:value="dialogState.city"
                class="set-select-width"
                :label="$t('myLearning.edit.city')"
                :optionList="cityList.map(i => ({ label: i, value: i }))"
                :title="$t('myLearning.tips.city')"
              />
              <Input v-else v-model:value="dialogState.city" class="set-select-width" :label="$t('myLearning.edit.city')" :title="$t('myLearning.tips.city')" />
            </a-form-item>
          </div>
          <div :class="{ 'flex-line': !isMobile }">
            <a-form-item name="VAT" v-if="formItemDisplay('vatNumber')" :class="{ 'margin-right-20': !isMobile && formItemDisplay('postcode') }">
              <Input v-model:value="dialogState.vatNumber" :label="$t('myLearning.edit.vat')" :maxlength="50" :title="$t('myLearning.tips.vat')" @input="e => vatNumberInput(e)" />
            </a-form-item>
            <a-form-item name="postcode" v-if="formItemDisplay('postcode')" >
              <Input v-model:value="dialogState.postcode" :label="$t('myLearning.edit.postcode')" :maxlength="30" :title="$t('myLearning.tips.postcode')" />
            </a-form-item>
          </div>
          <div v-if="formItemDisplay('address')" class="">
            <a-form-item name="address">
              <Input
                v-model:value="dialogState.address"
                class="textarea-fix"
                style="width: 100%; margin-bottom: 0"
                :label="$t('myLearning.edit.address')"
                :textarea="true"
                :maxlength="200"
                :rows="3"
                :title="$t('myLearning.tips.address')"
              />
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
    <template #footer>
      <div class="modal-footer flex--box--center">
        <Button class="button confirm-btn" :disabled="disabled" @click="onSubmit">
          {{ $t('global.confirm') }}
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script lang='ts'>
import { defineComponent, ref, onMounted, reactive, computed } from 'vue'
import { Modal, Form } from 'ant-design-vue'
import { useRoute } from 'vue-router'
import Input from '@/components/form/input/index.vue'
import Select from '@/components/form/select/select.vue'
import Country from '@/components/form/select/country.vue'
import { useClientCompatibleHook } from '@/utils/hooks'
import { useStoreHooks } from '@/store/hook'
import { Button } from '@/components/common'
import { getSupplementInfo, getProvinceCityConfig } from '@/request/api/common'
import { ISupplyInfoItem } from '@/interface'
import { updateUserInfo } from '@/request/api/user'
import Message from '@/components/common/message'
import { useI18n } from 'vue-i18n'
import { toServerUrl, TENANT_ID_MAP } from '@/utils'
import { COUNTRY_QUERY_TYPE } from '@/utils/config'
import { IResponseData } from '~/typings'
import { useCourseDetailHook } from '@/utils/moduleHooks/course'

export default defineComponent({
  components: {
    Modal,
    Button,
    Input,
    Select,
    Country,
    'a-form': Form,
    'a-form-item': Form.Item
  },
  setup () {
    const { getters, state: _state, dispatch, commit } = useStoreHooks()
    const route = useRoute()
    type OptionalKeyObject = {
      [key: string]: any;
    }
    const { t } = useI18n()
    const countryList = ref<string[]>([])
    // 存放省市原始数据
    const rawData = ref<OptionalKeyObject>({})
    // 当用户选择国家把当前国家的省、城市存放到这里面
    const rawProvinceList = ref({} as Record<string, string[]>)
    // 当用户选择国家把当前国家的省存放到这里面
    const provinceList = ref<string[]>([])
    // 当用户选择省下的城市存放到这里面
    const cityList = ref<string[]>([])
    const province = ref('')
    const loading = ref(false)
    const { isMobile } = useClientCompatibleHook()
    const provinceDataUnavailable = ref(false)
    const fieldList = ref([] as ISupplyInfoItem[])
    const { enrollCourse } = useCourseDetailHook()
    const currentInfo = _state.global.countryList.find(item => item.languageList.find(i => i.id === _state.global.currentLangKey))
    const regionId = currentInfo?.languageList[0].regionId
    const dialogState = reactive({
      firstName: '',
      lastName: '',
      phoneNumber: '',
      address: '',
      postcode: '',
      // 如果设为空字符串，则影响select的placeholder显示
      country: '',
      province: '',
      city: '',
      phoneCode: '',
      vatNumber: ''
    } as Record<string, string>)
    const disabled = computed(() => {
      if (fieldList.value.length > 0) {
        const keyList = Object.keys(fieldList.value[0]) as Array<keyof ISupplyInfoItem>
        const necessaryKeys = keyList.filter((item: keyof ISupplyInfoItem) => fieldList.value[0][item] === '1')
        return necessaryKeys.some((item: string) => {
          if (item === 'vatNumber') {
            return !dialogState[item] || dialogState[item].length < 2 || dialogState[item].length > 50
          }
          if (item === 'phoneNumber') {
            return !dialogState.phoneNumber || !dialogState.phoneCode
          }
          return !dialogState[item]
        })
      }
      return false
    })
    const visible = computed(() => {
      return _state.global.gatherInfoVisible && getters['global/isLogin'] && getters['global/shouldUserSupplyInfo']
    })
    const isMicro = computed(() => {
      return _state.global.tenantId === TENANT_ID_MAP.micro
    })
    const formItemDisplay = (key: keyof ISupplyInfoItem): boolean => {
      if (fieldList.value.length > 0) return fieldList.value[0][key] === '1'
      return false
    }

    const setProvinceList = (countryName: string) => {
      Object.keys(rawData.value).forEach(item => {
        if (countryName === item) {
          rawProvinceList.value = rawData.value[item]
          Object.keys(rawData.value[item]).forEach((items, index) => {
            provinceList.value[index] = items
          })
        }
      })
    }

    const setCityList = (province: string) => {
      cityList.value = rawProvinceList.value[province] || []
    }

    const onChangeCountry = (val: string) => {
      dialogState.province = ''
      dialogState.city = ''
      dialogState.country = val
      cityList.value = []
      provinceList.value = []
      setProvinceList(val)
    }

    const onChangeProvince = (val: string) => {
      dialogState.city = ''
      setCityList(val)
    }

    const vatNumberInput = (e: string) => {
      if (e) {
        dialogState.vatNumber = e.replace(/[^0-9;]/g, '')
      }
    }

    const onSubmit = () => {
      const params: { [key: string]: string } = {}
      Object.keys(fieldList.value[0]).forEach((item: string) => {
        if (fieldList.value[0][item as keyof ISupplyInfoItem] === '1') {
          params[item] = dialogState[item] || ''
          if (item === 'phoneNumber') {
            params.phoneCode = dialogState.phoneCode || ''
          }
          if (item === 'country') {
            const countryItem = _state.common.countryList.find(i => i.name === dialogState[item])
            params.countryCode = countryItem ? countryItem.countryCode : ''
          }
        }
      })
      loading.value = true
      const _params = Object.assign({}, _state.global.userInfo, params)
      updateUserInfo(_params).then(res => {
        if (res.code === 200) {
          Message.success(t('myLearning.successModify'))
          commit('global/setGatherInfoVisible', false)
          commit('global/setUserInfo', _params)
          if (_state.global.microEnrollCourse) {
            enrollCourse(undefined, (route.query.courseType || '0') as string)
            commit('global/setMicroEnrollCourse', false)
          }
          // 如果用户在个人信息编辑页提交了补充信息，则跳转到my-learning页面
          if (route.path === '/my-learning/edit') {
            toServerUrl('/my-learning')
          }
        }
      }).finally(() => {
        loading.value = false
      })
    }

    const initData = () => {
      const userInfo = _state.global.userInfo
      if (!userInfo) {
        return
      }
      dialogState.firstName = userInfo?.firstName
      dialogState.lastName = userInfo?.lastName
      dialogState.phoneNumber = userInfo?.phoneNumber
      dialogState.address = userInfo?.address
      dialogState.postcode = userInfo?.postcode
      dialogState.phoneCode = userInfo?.phoneCode
      dialogState.vatNumber = userInfo?.vatNumber
      if (!provinceDataUnavailable.value) {
        // 配置了国家省份时，先判断用户信息是否属于配置的数据
        if (userInfo?.country && countryList.value.some(i => i === userInfo.country)) {
          dialogState.country = userInfo.country
          setProvinceList(userInfo.country)
          setCityList(userInfo.province)
        }
        if (userInfo?.province && provinceList.value.some(i => i === userInfo.province)) {
          dialogState.province = userInfo.province
        }
        if (userInfo?.city && cityList.value.some(i => i === userInfo.city)) {
          dialogState.city = userInfo.city
        }
      } else {
        dialogState.country = userInfo?.country
        dialogState.province = userInfo?.province
        dialogState.city = userInfo?.city
      }
    }

    const getCountryRegionInfo = async () => {
      if (!provinceDataUnavailable.value) {
        // 初始化一下国家数据，方便后面使用
        return await dispatch('common/getCountryList', { countryQueryType: COUNTRY_QUERY_TYPE.all })
      }
    }

    onMounted(async () => {
      const resultList: IResponseData[] = await Promise.all([
        getSupplementInfo({ regionId: regionId as number }),
        getProvinceCityConfig()
      ])
      if (resultList[0].code === 200) {
        fieldList.value = (resultList[0]?.data || []) as ISupplyInfoItem[]
        // 如果省份非必填将城市改为非必填
        if (fieldList.value[0]?.province === '0') {
          fieldList.value[0].city = '0'
        }
        fieldList.value = fieldList.value.map(item => ({
          firstName: item.firstName,
          lastName: item.lastName,
          phoneNumber: item.phoneNumber,
          address: item.address,
          postcode: item.postcode,
          country: item.country,
          province: item.province,
          city: item.city,
          phoneCode: item.phoneCode,
          vatNumber: item.vatNumber
        })) as ISupplyInfoItem[]
        commit('global/setSupplyInfo', fieldList.value)
      }
      if (resultList[1].code === 200) {
        countryList.value = []
        rawData.value = resultList[1]?.data || {}
        provinceDataUnavailable.value = !rawData.value || !Object.keys(rawData.value).length
        if (!provinceDataUnavailable.value) {
          Object.keys(rawData.value).forEach(item => countryList.value.push(item))
        }
      }
      await getCountryRegionInfo()
      initData()
    })

    return {
      isMobile,
      dialogState,
      loading,
      onSubmit,
      formItemDisplay,
      onChangeCountry,
      onChangeProvince,
      provinceList,
      visible,
      cityList,
      disabled,
      province,
      provinceDataUnavailable,
      countryList,
      isMicro,
      isArSite: computed(() => _state.global.isArSite),
      vatNumberInput
    }
  }
})
</script>
<style scoped lang='less'>
@pc-padding: 34px;
// .PCstyle {
//   width: 742px;
// }
:deep(.ant-form-item .ant-input-textarea-show-count::after) {
  margin-bottom: 0;
}

.information-dialog-background {
  background-image: url('/image/homepage/infomation-dialog-background.png');
  background-repeat: no-repeat;
  background-position: top -@pc-padding left  -@pc-padding;
}

.information-dialog-background-m {
  background-image: url('/image/homepage/infomation-dialog-background-m.png');
  background-repeat: no-repeat;
  background-position: top -4rem left -3.5rem;
}

.information-gathering-container {
  padding: @pc-padding @pc-padding 0;
  position: relative;
  .ant-form-item {
    margin-bottom: 0;
  }
  .information-background {
    position: absolute;
    top: -34px;
    left: -34px;
    z-index: 0;
    width: 100%;
  }

  .margin-right-20 {
    margin-right: 20px;
  }
  .flex-line {
    display: flex;
    align-items: center;
    .ant-row {
      flex: 1;
    }
  }
  .information-gathering-title {
    color: rgb(34, 34, 34);
    font-size: 24px;
    font-weight: 700;
    line-height: 33px;
    letter-spacing: 0px;
    margin-bottom: 20px;
  }

  .information-gathering-illustrates {
    color: rgb(51, 51, 51);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0px;
    margin-bottom: 20px;
  }

  .information-gathering-infor {
    .set-select-width {
      width: 100%;
    }

    .select-list {
      width: 100%
    }

    .first-name-display-inline-block {
      display: inline-block;
      width: calc((100% - 20px)/2);
    }

    .last-name-display-inline-block {
      display: inline-block;
      width: calc((100% - 20px)/2);
    }

    .information-gathering-infor-code {
      display: inline-block;
      width: 100px;
      margin-right: 10px;
    }

    .information-gathering-infor-phone-number {
      display: inline-block;
      width: calc(100% - 110px);
    }
  }
}

.modal-footer {
  padding-bottom: 20px;
  margin-top: 20px;
  .button {
    height: 32px;
  }
}
:deep(.ant-input-affix-wrapper) {
  border-color: #d9d9d9;
  box-shadow: none;
  &:hover {
    border-color: #333;
  }
}
:deep(.ant-input-textarea) {
  &::after {
    right: 33px !important;
  }
}
.link {
  color: #007AFF;
  &:hover {
    text-decoration: underline;
  }
}

@media only screen and (max-width: 992px) {
  .set-mobile-padding {
    padding: 1.5rem 1.5rem 0;
  }
  .information-gathering-container {
    .set-mobile-title {
      font-size: 1.6rem;
      margin-bottom: 1.2rem;
      line-height: 2.4rem;
    }
    .set-mobile-illustrates {
      font-size: 1.4rem;
      margin-bottom: 1.5rem;
    }
    .modal-footer {
      padding-bottom: 2rem;
      margin-top: 2rem;
      .button {
        min-width: 8.8rem;
        height: 3.2rem;
      }
    }
  }

}

.rtl--container {
  .info-new-line {
    :deep(.ant-input-textarea) {
      &::after {
        left: 33px !important;
        right: auto !important;
      }
    }
  }
  .information-gathering-container {
    .margin-right-20 {
      margin-right: 0;
      margin-left: 20px;
    }
  }
  .information-gathering-container .information-gathering-infor .information-gathering-infor-code {
    margin-right: 0;
    margin-left: 10px;
  }
}
</style>
